<template>
    <div class="ldc-dropdown" v-if="checkDropdown" v-click-outside="outside">
        <slot/>
    </div>
</template>
<script>
export default {
    props: {
        activeDropdown: {
            type: Boolean,
        }
    },
    data(){
        return {
            checkDropdown: true,
            actionShow: 'hover',
            actionClose: '',
            active: false,
        }
    },
    created() {
        let el = this.$slots.default;
        if(!el || el.length != 2){
            console.error('There was an error rendering <ldc-dropdown/>, ldc-dropdown is only 2 main blocks including 1 ldc-dropdown-content component')
            this.checkDropdown = false;
        }else if(el[0].componentOptions && el[0].componentOptions.tag === 'ldc-dropdown-menu'){
            console.log('There was an error rendering <ldc-dropdown/>, first block not is a component ldc-dropdown-menu');
            this.checkDropdown = false;
        }else if(!el[1].componentOptions || el[1].componentOptions.tag !== 'ldc-dropdown-menu'){
            console.log('There was an error rendering <ldc-dropdown/>, last block is a component ldc-dropdown-menu');
            this.checkDropdown = false;
        }

        let attrs = this.$attrs;
        if(attrs.trigger == 'click' || attrs.trigger == 'hover'){
            this.actionShow = attrs.trigger;
        }

        if(typeof(attrs['action-close']) == 'boolean'){
            this.actionClose = attrs['action-close'];
        }
    },
    watch: {
        activeDropdown(val){
            setTimeout(() => {
                this.$slots.default[1].componentInstance.show = val;
            }, 1);
        },
        active(val){
            this.$emit('update:activeDropdown', val)
        }
    },
    mounted(){
        if(this.actionShow == 'hover'){
            this.$el.onmouseover = () => {
                this.$slots.default[1].componentInstance.show = true;
                this.emitShow(true);
            }
            this.$el.onmouseleave = () => {
                this.$slots.default[1].componentInstance.show = false;
                this.emitShow(false);
            }
        }else{
            this.$slots.default[0].elm.onclick = () => {
                this.$slots.default[1].componentInstance.show = true;
                this.emitShow(true);
            }
        }
        this.setDomClose();
    },
    methods: {
        outside(e){
            if(this.actionShow == 'click'){
                this.$slots.default[1].componentInstance.show = false;
                this.emitShow(false);
            }
        },
        emitShow(show){
            this.$emit('dataActive', show);
        },
        setDomClose(){
            if(this.actionClose){
                let dom = this.$el.querySelectorAll('[close-dropdown]');
                for(let i = 0; i < dom.length; i++){
                    if(dom[i].getAttribute('close-dropdown') !== false){
                        dom[i].onclick = () => {
                            this.$slots.default[1].componentInstance.show = false;
                            this.emitShow(false);
                        }
                    }
                }
            }
        }
    }
}
</script>